import React from 'react';
import { motion } from 'framer-motion';
import { CalendarIcon, TrendingUpIcon } from 'lucide-react';
export function ProofSection() {
  return <section className="py-20 bg-brandOrange-500 text-white px-4" data-id="element-188">
      <div className="max-w-4xl mx-auto text-center" data-id="element-189">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-190">
          <div className="flex justify-center mb-6" data-id="element-191">
            <CalendarIcon className="w-16 h-16 text-white/80" data-id="element-192" />
          </div>
          <h2 className="text-4xl md:text-6xl font-bold mb-8 drop-shadow-md" data-id="element-193">
            Lo Que Cambia En 7 Días
          </h2>

          <div className="bg-white/10 backdrop-blur-md p-8 md:p-12 rounded-2xl border border-white/20 text-left relative overflow-hidden" data-id="element-194">
            <TrendingUpIcon className="absolute -right-10 -bottom-10 w-64 h-64 text-white/5" data-id="element-195" />

            <p className="text-xl md:text-2xl font-medium leading-relaxed relative z-10" data-id="element-196">
              En una semana, habrás pasado de tener una idea borrosa en la
              cabeza a tener un{' '}
              <strong className="text-navy-900 bg-white px-2 py-1 rounded" data-id="element-197">
                enlace real
              </strong>{' '}
              que puedes enviar a clientes potenciales, una pasarela de pagos
              activa recibiendo depósitos y la confianza de saber que ya no eres
              un espectador, sino un{' '}
              <strong className="underline decoration-4 underline-offset-4" data-id="element-198">
                dueño de negocio en línea
              </strong>
              .
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}